<template>
  <v-card flat class="site-wrapper">
    <div class="support-wrapper">
      <v-row>
        <v-col cols="12" sm="4">
          <div class="id-search-wrapper">
            <LinkNavigator />
            <MailReSender />
          </div>
        </v-col>
        <v-col cols="12" sm="4">
          <div class="column-wrapper">
            <SourceTracker />
            <LeadsTracker />
          </div>
        </v-col>
        <v-col cols="12" sm="4">
          <div class="column-wrapper">
            <LeadGenerator />
            <LeadJSONSender />
          </div>
        </v-col>
      </v-row>
    </div>
  </v-card>
</template>

<script>
import LinkNavigator from "./supportHelpers/LinkNavigator.vue";
import LeadGenerator from "./supportHelpers/LeadGenerator.vue";
import LeadJSONSender from "./supportHelpers/LeadJSONSender.vue";
import LeadsTracker from "./supportHelpers/LeadsTracker.vue";
import SourceTracker from "./supportHelpers/SourceTracker.vue";
import MailReSender from "./supportHelpers/MailReSender.vue";

export default {
  components: {
    LinkNavigator,
    LeadGenerator,
    LeadJSONSender,
    LeadsTracker,
    SourceTracker,
    MailReSender,
  },
  data() {
    return {
      showTitle: false,
    };
  },
  mounted() {
    this.showTitle = true;
  },
};
</script>

<style lang="scss" scoped>
.support-wrapper {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0 20px;
}

.id-search-wrapper {
  display: flex;
  flex-direction: column;
  gap: 12px;
}

.search-wrapper {
  display: flex;
  flex-direction: column;
  gap: 12px;
  padding: 16px;
  border: 1px solid rgb(196, 196, 196);
  border-radius: 12px;
  background-color: white;
}

.column-wrapper {
  display: flex;
  flex-direction: column;
  gap: 12px;
}

.search-field {
  width: 100%;
  height: 40px;
}
</style>

